module.exports = __webpack_public_path__ + "static/media/usa.d31a6f66.png";